import { Box, Typography, styled } from '@mui/material';

export const Hero = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'compact',
})<{ compact?: boolean }>(({ theme, compact }) => ({
  position: 'relative',
  overflow: 'hidden',
  background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
  color: theme.palette.common.white,
  padding: compact ? '18px 22px' : '18px 34px',
  display: 'flex',
  alignItems: 'center',
  gap: compact ? '13px' : '16px',
  '&::after': {
    content: '""',
    position: 'absolute',
    right: '-60px',
    top: '-90px',
    width: '280px',
    height: '280px',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(245,179,0,.22), transparent 70%)',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '18px 18px',
  },
}));

export const HeroBadge = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'compact',
})<{ compact?: boolean }>(({ compact }) => ({
  position: 'relative',
  zIndex: 1,
  flexShrink: 0,
  width: compact ? 38 : 46,
  height: compact ? 38 : 46,
  borderRadius: compact ? '10px' : '13px',
  backgroundColor: 'rgba(255,255,255,.14)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const HeroText = styled(Box)({
  position: 'relative',
  zIndex: 1,
  minWidth: 0,
  flex: 1,
});

export const HeroTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'compact',
})<{ compact?: boolean }>(({ theme, compact }) => ({
  fontSize: compact ? '18px' : '22px',
  fontWeight: 700,
  letterSpacing: '-.2px',
  lineHeight: 1.1,
  color: '#fff',
  [theme.breakpoints.down('sm')]: { fontSize: '17px' },
}));

export const HeroSubtitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'compact',
})<{ compact?: boolean }>(({ theme, compact }) => ({
  fontSize: compact ? '12.5px' : '14px',
  lineHeight: 1.3,
  color: 'rgba(255,255,255,.8)',
  marginTop: compact ? '2px' : '4px',
  [theme.breakpoints.down('sm')]: { fontSize: '12px' },
}));

export const HeroCloseButton = styled('button')({
  position: 'relative',
  zIndex: 3,
  flexShrink: 0,
  alignSelf: 'flex-start',
  width: 32,
  height: 32,
  border: 'none',
  borderRadius: '9px',
  cursor: 'pointer',
  background: 'rgba(255,255,255,.16)',
  color: '#fff',
  fontSize: '19px',
  lineHeight: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'background .12s',
  fontFamily: 'inherit',
  padding: 0,
  '&:hover': {
    background: 'rgba(255,255,255,.3)',
  },
});
